import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ImportPracticesDialog from './ImportPracticesDialog';

const fabPosition = {
  position: 'absolute',
  bottom: 30,
  right: 30,
};

/**
 * SpeedDial fab for the Practices page, shown when the PRACTICES_IMPORT_FEATURES
 * flag is on. Offers the existing "new practice" action plus a ".csv import" one
 * that opens a drag-and-drop dialog. When the flag is off the page falls back to
 * the standard single fab rendered by EntriesWrapper, so this component is only
 * mounted while the feature is enabled.
 */
const PracticesFab = function PracticesFab({
  branchName = '',
  onNewPractice = () => {},
  onUploadCsv = () => {},
}) {
  const intl = useIntl();
  const [importOpen, setImportOpen] = useState(false);

  return (
    <>
      <SpeedDial
        ariaLabel={intl.messages.NEW_PRACTICE}
        icon={<SpeedDialIcon />}
        sx={fabPosition}
      >
        <SpeedDialAction
          icon={<NoteAddIcon />}
          slotProps={{ tooltip: { title: intl.messages.NEW_PRACTICE } }}
          onClick={onNewPractice}
        />
        <SpeedDialAction
          icon={<UploadFileIcon />}
          slotProps={{
            tooltip: { title: intl.messages.IMPORT_PRACTICES_CSV },
          }}
          onClick={() => setImportOpen(true)}
        />
      </SpeedDial>
      <ImportPracticesDialog
        open={importOpen}
        branchName={branchName}
        onClose={() => setImportOpen(false)}
        onConfirm={(file) => {
          onUploadCsv(file);
          setImportOpen(false);
        }}
      />
    </>
  );
};

PracticesFab.propTypes = {
  branchName: PropTypes.string,
  onNewPractice: PropTypes.func,
  onUploadCsv: PropTypes.func,
};

export default PracticesFab;
